export enum DashboardLocation {
  Main = 0,
  RightSide = 1,
  Disabled = 2,
}
